import { RouteConfig } from '../interface'

const storeRoutes: RouteConfig[] = [
  {
    path: '/settings/shopee-food',
    redirect: '/settings/shopee-food/business-hours-settings',
  },
  {
    path: '/settings/shopee-food/setting',
    component: () => import(/* webpackChunkName: "Store-Settings" */ '@/pages/Settings'),
  },
  {
    path: '/settings/shopee-food/business-hours',
    redirect: '/settings/shopee-food/business-hours-settings/business-hours',
  },
  {
    path: '/settings/shopee-food/business-hours-settings',
    component: () =>
      import(
        /* webpackChunkName: "Store-Business-Hours-Settings" */ '@/pages/Settings/BusinessHours'
      ),
  },
  {
    path: '/settings/shopee-food/business-hours-settings/business-hours',
    component: () =>
      import(
        /* webpackChunkName: "Store-Business-Hours" */ '@/pages/Settings/BusinessHours/HoursSettings'
      ),
  },
  {
    path: '/settings/shopee-food/order-settings',
    component: () =>
      import(/* webpackChunkName: "Store-Order-Settings" */ '@/pages/Settings/OrderSettings'),
  },
]

export default storeRoutes
